import { render, staticRenderFns } from "./page-view.vue?vue&type=template&id=6b9c97c7"
import script from "./page-view.vue?vue&type=script&lang=ts"
export * from "./page-view.vue?vue&type=script&lang=ts"
import style0 from "./page-view.vue?vue&type=style&index=0&id=6b9c97c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports